import baseDiscoverService from './base/baseDiscoverService.js';

const RUNNING_ASSESSMENT_STATUSES = ["generating_queries", "executing_queries", "aggregating"];
var BillingMode;
(function (BillingMode) {
    BillingMode["Enterprise"] = "enterprise";
    BillingMode["Demo"] = "demo";
    BillingMode["SelfServe"] = "self-serve";
})(BillingMode || (BillingMode = {}));
const createFreeReport = (payload, config) => {
    return baseDiscoverService.post("api/reports/free-report", payload, config);
};
const createReport = (payload, config) => {
    return baseDiscoverService.post("api/reports", payload, config);
};
const createMarketProfileReport = (payload, config) => {
    return baseDiscoverService.post("api/reports/market-profile", payload, config);
};
const continueAssessment = (assessmentId, payload, config) => {
    return baseDiscoverService.post(`api/reports/${assessmentId}/continue`, payload || {}, config);
};
const getAssessmentStatus = (assessmentId, config) => {
    return baseDiscoverService.get(`api/reports/${assessmentId}`, config);
};
const getAiDiscoverabilityReport = (id, config) => {
    return baseDiscoverService.get(`api/reports/${id}`, config);
};
const getAiDiscoverabilityReports = (params, config) => {
    var _a;
    const queryParams = ((_a = params === null || params === void 0 ? void 0 : params.ids) === null || _a === void 0 ? void 0 : _a.length) ? { ids: params.ids.join(",") } : undefined;
    return baseDiscoverService.get(`api/reports`, Object.assign(Object.assign({}, config), { params: queryParams }));
};
const getDiscoverSubjectTimeSeries = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/time-series`, config);
};
const getDiscoverSubjectTopSources = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/top-sources`, config);
};
const updateDiscoverOrganization = (organizationId, payload, config) => {
    return baseDiscoverService.put(`api/organizations/${organizationId}`, payload, config);
};
const updateDiscoverSubject = (subjectId, payload, config) => {
    return baseDiscoverService.put(`api/subjects/${subjectId}`, payload, config);
};
const createDiscoverSubject = (payload, config) => {
    return baseDiscoverService.post(`api/subjects`, payload, config);
};
const getDiscoverSubjectById = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}`, config);
};
const getDiscoverSubjects = (params, config) => {
    return baseDiscoverService.get(`api/subjects`, Object.assign(Object.assign({}, config), { params }));
};
const getDiscoverOrganizations = (config) => {
    return baseDiscoverService.get(`api/organizations`, config);
};
const createDiscoverOrganization = (payload, config) => {
    return baseDiscoverService.post(`api/organizations`, payload, config);
};
const deleteDiscoverSubject = (subjectId, config) => {
    return baseDiscoverService.delete(`api/subjects/${subjectId}`, config);
};
const deleteDiscoverOrganization = (organizationId, config) => {
    return baseDiscoverService.delete(`api/organizations/${organizationId}`, config);
};
const requestDemoAccess = (payload, config) => {
    return baseDiscoverService.post("api/demo/access", payload, config);
};
const getTopCompetitors = (subjectId, assessmentId, config) => {
    const params = assessmentId ? { assessmentId } : undefined;
    return baseDiscoverService.get(`api/subjects/${subjectId}/top-competitors`, Object.assign(Object.assign({}, config), { params }));
};
const getMentionedCommunities = (subjectId, competitor, limit = 10, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/mentioned-communities`, Object.assign(Object.assign({}, config), { params: { competitor, limit } }));
};
const getAssessmentTemplateTrackedCompetitors = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/tracked-competitors`, config);
};
const replaceTrackedCompetitors = (subjectId, payload, config) => {
    return baseDiscoverService.put(`api/subjects/${subjectId}/tracked-competitors`, payload, config);
};
const getWhiskerDistribution = (subjectId, assessmentId, config) => {
    const params = assessmentId ? { assessmentId } : undefined;
    return baseDiscoverService.get(`api/subjects/${subjectId}/whisker-distribution`, Object.assign(Object.assign({}, config), { params }));
};
const getTrackedCompetitors = (subjectId, assessmentId, config) => {
    const params = assessmentId ? { assessmentId } : undefined;
    return baseDiscoverService.get(`api/subjects/${subjectId}/competitor-rankings`, Object.assign(Object.assign({}, config), { params }));
};
const signupAiDiscover = (payload, config) => {
    return baseDiscoverService.post("auth/signup", payload, config);
};
const createAssessmentTemplate = (payload, config) => {
    return baseDiscoverService.post("api/assessment-templates", payload, config);
};
const updateAssessmentTemplate = (templateId, payload, config) => {
    return baseDiscoverService.put(`api/assessment-templates/${templateId}`, payload, config);
};
const getAssessmentTemplates = (params, config) => {
    return baseDiscoverService.get("api/assessment-templates", Object.assign(Object.assign({}, config), { params }));
};
const getAssessmentTemplate = (templateId, config) => {
    return baseDiscoverService.get(`api/assessment-templates/${templateId}`, config);
};
const toggleAssessmentTemplateStatus = (templateId, action, config) => {
    return baseDiscoverService.patch(`api/assessment-templates/${templateId}/${action}`, {}, config);
};
const forkAssessmentTemplateWithCollection = (templateId, payload, config) => {
    return baseDiscoverService.post(`api/assessment-templates/${templateId}/update-collection`, payload, config);
};
// ── Assessment Variable Collections ──
const VariableOverrideAction = {
    SET: "set",
    REMOVE: "remove",
};
const createAssessmentVariableCollection = (payload, config) => {
    return baseDiscoverService.post("api/assessment-variable-collections", payload, config);
};
const updateAssessmentVariableCollection = (collectionId, payload, config) => {
    return baseDiscoverService.put(`api/assessment-variable-collections/${collectionId}`, payload, config);
};
const seedBaseVariables = (collectionId, payload, config) => {
    return baseDiscoverService.post(`api/assessment-variable-collections/${collectionId}/seed-base-variables`, payload || {}, config);
};
const getAssessmentVariableCollection = (collectionId, config) => {
    return baseDiscoverService.get(`api/assessment-variable-collections/${collectionId}`, config);
};
const getAssessmentVariablesByAssessmentId = (assessmentId, config) => {
    return baseDiscoverService.get(`api/assessment-variables/${assessmentId}`, config);
};
// organizationBilling.ts on the BE keys every billing route by org in the PATH
// (/api/organizations/:organizationId/billing/...), including licenses.
const orgBilling = (organizationId) => `api/organizations/${organizationId}/billing`;
const getBilling = (organizationId, config) => {
    return baseDiscoverService.get(orgBilling(organizationId), config);
};
const getBillingSubscription = (organizationId, config) => {
    return baseDiscoverService.get(`${orgBilling(organizationId)}/subscription`, config);
};
const getBillingSubscriptions = (organizationId, config) => {
    return baseDiscoverService.get(`${orgBilling(organizationId)}/subscriptions`, config);
};
const getBillingPaymentMethods = (organizationId, config) => {
    return baseDiscoverService.get(`${orgBilling(organizationId)}/payment-methods`, config);
};
const getBillingInvoices = (organizationId, config) => {
    return baseDiscoverService.get(`${orgBilling(organizationId)}/invoices`, config);
};
const getBillingPlans = (organizationId, config) => {
    return baseDiscoverService.get(`${orgBilling(organizationId)}/plans`, config);
};
const createBillingSetupIntent = (organizationId, config) => {
    return baseDiscoverService.post(`${orgBilling(organizationId)}/setup-intent`, {}, config);
};
const createBillingSubscription = (organizationId, payload, config) => {
    return baseDiscoverService.post(`${orgBilling(organizationId)}/subscription`, payload, config);
};
const deleteBillingPaymentMethod = (organizationId, paymentMethodId, config) => {
    return baseDiscoverService.delete(`${orgBilling(organizationId)}/payment-methods/${paymentMethodId}`, config);
};
// Prefer the deterministic id-based route; the no-id alias (single active sub,
// 409 if ambiguous) is the fallback when no subscriptionId is known.
const cancelBillingSubscription = (organizationId, subscriptionId, config) => {
    const path = subscriptionId
        ? `${orgBilling(organizationId)}/subscriptions/${subscriptionId}`
        : `${orgBilling(organizationId)}/subscription`;
    return baseDiscoverService.delete(path, config);
};
const reactivateBillingSubscription = (organizationId, subscriptionId, config) => {
    const path = subscriptionId
        ? `${orgBilling(organizationId)}/subscriptions/${subscriptionId}`
        : `${orgBilling(organizationId)}/subscription`;
    return baseDiscoverService.patch(path, {}, config);
};
const getBillingLicenses = (organizationId, config) => {
    return baseDiscoverService.get(`${orgBilling(organizationId)}/licenses`, config);
};
const assignBillingLicense = (subscriptionId, subjectId, organizationId, config) => {
    return baseDiscoverService.post(`${orgBilling(organizationId)}/licenses/${subscriptionId}/assign`, { subjectId }, config);
};
const unassignBillingLicense = (subscriptionId, subjectId, organizationId, config) => {
    return baseDiscoverService.post(`${orgBilling(organizationId)}/licenses/${subscriptionId}/unassign`, { subjectId }, config);
};
const markOrganizationAsEnterprise = (organizationId, config) => {
    return baseDiscoverService.put(`${orgBilling(organizationId)}/enterprise`, {}, config);
};
const getDiscoverSubjectRecommendationRuns = (subjectId, assessmentId, config) => {
    const params = assessmentId ? { assessmentId } : undefined;
    return baseDiscoverService.get(`api/subjects/${subjectId}/recommendation-runs`, Object.assign(Object.assign({}, config), { params }));
};

export { BillingMode, RUNNING_ASSESSMENT_STATUSES, VariableOverrideAction, assignBillingLicense, cancelBillingSubscription, continueAssessment, createAssessmentTemplate, createAssessmentVariableCollection, createBillingSetupIntent, createBillingSubscription, createDiscoverOrganization, createDiscoverSubject, createFreeReport, createMarketProfileReport, createReport, deleteBillingPaymentMethod, deleteDiscoverOrganization, deleteDiscoverSubject, forkAssessmentTemplateWithCollection, getAiDiscoverabilityReport, getAiDiscoverabilityReports, getAssessmentStatus, getAssessmentTemplate, getAssessmentTemplateTrackedCompetitors, getAssessmentTemplates, getAssessmentVariableCollection, getAssessmentVariablesByAssessmentId, getBilling, getBillingInvoices, getBillingLicenses, getBillingPaymentMethods, getBillingPlans, getBillingSubscription, getBillingSubscriptions, getDiscoverOrganizations, getDiscoverSubjectById, getDiscoverSubjectRecommendationRuns, getDiscoverSubjectTimeSeries, getDiscoverSubjectTopSources, getDiscoverSubjects, getMentionedCommunities, getTopCompetitors, getTrackedCompetitors, getWhiskerDistribution, markOrganizationAsEnterprise, reactivateBillingSubscription, replaceTrackedCompetitors, requestDemoAccess, seedBaseVariables, signupAiDiscover, toggleAssessmentTemplateStatus, unassignBillingLicense, updateAssessmentTemplate, updateAssessmentVariableCollection, updateDiscoverOrganization, updateDiscoverSubject };
